'use strict';

import React from 'react';
import {
  autocompleteListItemClassName,
  autocompleteListItemStyle
} from 'helpers/classNameStyles';
import {
  matchClfTargetTextToTerm,
  sortClfTargets
} from 'helpers/matchers';
import Autocomplete from 'components/clarity-ui/inputs/autocomplete';
import NavigationTabs from 'components/clarity-ui/components/tabs/navigationTabs';
import Tab from 'components/clarity-ui/components/tabs/tab';
import TargetLabelTable from './targetLabelTable.component';
import AttachedLabels from './attachedLabels/attachedLabels.component';
import TargetResults from './targetResults/targetResults.component';
import MTurk from './mturk/mturk.component';

class ClassifierTargetsComponent extends React.Component {

  renderMTurk () {
    const { turkQaEnabled, mturkActiveTab, handleMTurkNavTabChange, loadingComponent, pageNotification,
      mturkHitEvaluator, handleHitEvaluatorInputOnChange, handleSaveHitEvaluatorOnClick } = this.props;
    return (
      <MTurk
        turkQaEnabled={turkQaEnabled}
        mturkActiveTab={mturkActiveTab}
        loadingComponent={loadingComponent}
        mturkHitEvaluator={mturkHitEvaluator}
        pageNotification={pageNotification}
        handleMTurkNavTabChange={handleMTurkNavTabChange}
        handleHitEvaluatorInputOnChange={handleHitEvaluatorInputOnChange}
        handleSaveHitEvaluatorOnClick={handleSaveHitEvaluatorOnClick}/>
    );
  }

  renderDetectorResults () {
    const { textDetectorResults, videoDetectorResults, boxDetectorResults,
      handleThumbnailOnClick, handleSliderOnChange } = this.props;

    return (
      <TargetResults
        textDetectorResults={textDetectorResults}
        boxDetectorResults={boxDetectorResults}
        videoDetectorResults={videoDetectorResults}
        handleThumbnailOnClick={handleThumbnailOnClick}
        handleSliderOnChange={handleSliderOnChange}/>
    );
  }

  renderAttachedLabels () {
    const { clfTarget,  labelToAdd, handleSaveOnClick,
      handleAddLabelWeightOnChange, handleAddButtonOnClick,
      handleLabelsAutocompleteOnChange, handleLabelsAutocompleteSelect,
      handleRemoveWeightedLabelsOnClick, handleWeightInputOnChange,
      pageNotification, filteredLabels, labelAutocompleteInputValue
    } = this.props;

    return (
      <AttachedLabels
        pageNotification={pageNotification}
        clfTarget={clfTarget}
        filteredLabels={filteredLabels}
        labelToAdd={labelToAdd}
        labelAutocompleteInputValue={labelAutocompleteInputValue}
        handleSaveOnClick={handleSaveOnClick}
        handleAddLabelWeightOnChange={handleAddLabelWeightOnChange}
        handleAddButtonOnClick={handleAddButtonOnClick}
        handleRemoveWeightedLabelsOnClick={handleRemoveWeightedLabelsOnClick}
        handleWeightInputOnChange={handleWeightInputOnChange}
        handleLabelsAutocompleteSelect={handleLabelsAutocompleteSelect}
        handleLabelsAutocompleteOnChange={handleLabelsAutocompleteOnChange}
      />
    );
  }

  renderSelectedTabView (activeTab) {
    switch (activeTab) {
      case 'attachedLabelsTab':
        return this.renderAttachedLabels();
      case 'resultsTab':
        return this.renderDetectorResults();
      case 'mturkTab':
        return this.renderMTurk();
      default:
        return null;
    }
  }

  renderTabSection () {
    const { handleNavigationTabChange, activeTab } = this.props;
    return (
      <div>
        <div>
          <NavigationTabs>
            <Tab id="attachedLabelsTab" onClick={handleNavigationTabChange} isActive={activeTab === 'attachedLabelsTab'}>Attached Labels</Tab>
            <Tab id="mturkTab" onClick={handleNavigationTabChange} isActive={activeTab === 'mturkTab'}>MTurk</Tab>
            {/*<Tab id="resultsTab" onClick={handleNavigationTabChange} isActive={activeTab === 'resultsTab'}>Detector Results</Tab>*/}
          </NavigationTabs>
        </div>
        <div className="EntityShowCase">
          { this.renderSelectedTabView(activeTab) }
        </div>
      </div>
    );
  }

  renderTargetLabelsAutocomplete (classifierTargetLabels, handleSelect, handleOnChange) {
    return (
      <Autocomplete
        inputProps={{className:'InputField-input'}, {placeholder:'Filter Target Labels'}}
        onSelect={handleSelect}
        onChange={handleOnChange}
        items={classifierTargetLabels}
        getItemValue={(clfTarget) => clfTarget.targetLabel.name}
        shouldItemRender={matchClfTargetTextToTerm}
        sortItems={sortClfTargets}
        renderItem={(clfTarget, isHighlighted, styles) => (
          <li
            className={autocompleteListItemClassName(isHighlighted)}
            style={autocompleteListItemStyle(isHighlighted, styles)}
            key={clfTarget.targetLabel.id}
          >{clfTarget.targetLabel.name}</li>
        )}
      />
    );
  }

  render () {
    const { classifierId, targetLabels, /*clfTarget,*/ clfTargets, selectedClfTargetId,
      handleTargetTableClick, handleTargetLabelsAutocompleteSelect, handleOnTargetLabelsAutocompleteChange } = this.props;

    return (
      <div>
        <div className="BreakLine">
          { this.renderTargetLabelsAutocomplete(clfTargets, handleTargetLabelsAutocompleteSelect, handleOnTargetLabelsAutocompleteChange) }
        </div>
        <div className="BreakLine">
          Select a Classifier Target to display more options
        </div>
        <div className="BreakLine">
          <TargetLabelTable
            selectedClfTargetId={selectedClfTargetId}
            classifierId={classifierId}
            rowOnClick={handleTargetTableClick}
            targetLabels={targetLabels}/>
        </div>
        { targetLabels.length > 0 && !!selectedClfTargetId ? this.renderTabSection() : null }
      </div>
    );
  }
}

export default ClassifierTargetsComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/classifierTargets.component.jsx